import _ from "underscore";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";

import React from "react";

export default class HighlightText extends React.Component {
  static displayName = "HighlightText";

  static propTypes = {
    string: PropTypes.string,
    query: PropTypes.string,
    highlightStyle: PropTypes.object,
  };

  static defaultProps = {
    highlightStyle: {
      background: "#dfefcd",
    },
  };

  render() {
    const attrs = { className: this.props.className };
    if (!this.props.query) {
      return <span {...attrs}>{this.props.string}</span>;
    } else {
      const regex = new RegExp(`(${this.props.query})`, "gi");
      const string_pieces = __guardMethod__(this.props.string, "split", (o) => o.split(regex));

      return (
        <span {...attrs}>
          {_.map(string_pieces, (str, index) => {
            if (str.match(regex)) {
              return (
                <span style={this.props.highlightStyle} key={index}>
                  {str}
                </span>
              );
            } else {
              return str;
            }
          })}
        </span>
      );
    }
  }
}

function __guardMethod__(obj, methodName, transform) {
  if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") {
    return transform(obj, methodName);
  } else {
    return undefined;
  }
}
